// ===============================
// GENERAL
// ===============================
export const VERSION = process.env.REACT_APP_VERSION;
export const USED_COLLECTIONS = process.env.REACT_APP_COLLECTIONS.split(',');
// GOOGLE RECAPTCHA KEY
export const GOOGLE_RECAPTCHA_SITE_KEY = process.env.REACT_APP_GOOGLE_RECAPTCHA_SITE_KEY;
// ===============================
// API
// ===============================
// PIVAN API
export const ANONYMOUS_KEY = "1a442d8b-8fac-42de-ab33-303bdb9b3733";
export const API_URL = `${process.env.REACT_APP_API_DOMAIN}${process.env.REACT_APP_API_URL}`;
// IIIF SERVER
export const DIGILIB_BASE_URL = process.env.REACT_APP_IIIF_SERVER_DOMAIN;
export const DIGILIB_SCALER_URL = process.env.REACT_APP_DIGILIB_SCALER_URL;
export const DIGILIB_MANIFESTER_URL = process.env.REACT_APP_DIGILIB_MANIFESTER_URL;
export const USER_ROLES = {
    READER: "ROLE_READER",
    USER: "ROLE_USER",
    MODERATOR: "ROLE_MODERATOR",
    ADMIN: "ROLE_ADMIN",
}
export const COLLECTION_ROLE = {
    OWNER: "OWNER",
    MAINTAINER: "MAINTAINER",
    EDITOR: "EDITOR",
    READER: "READER"
}
// ===============================
// FOOTER
// ===============================
export const LAST_UPDATE = process.env.REACT_APP_LAST_UPDATE;
export const ASSOCIATES = [
    {src: "/assets/litiswhite.png", alt: "LITIS", link: "https://www.litislab.fr/"},
    {src: "/assets/larhra-logo-white.png", alt: "LARHRA", link: "http://larhra.ish-lyon.cnrs.fr/"},
    {src: "/assets/univ-rouen-white.png", alt: "univ-rouen", link: "https://www.univ-rouen.fr/"},
    {src: "/assets/normandie-univ-white.png", alt: "normandie-univ", link: "https://www.normandie-univ.fr/"},
    {src: "/assets/logo_normandie-white.png", alt: "region-normandie", link: "https://www.normandie.fr/"},
    {
        src: "/assets/union-europeenne-white.png",
        alt: "ue-feder",
        link: "https://ec.europa.eu/regional_policy/fr/funding/erdf"
    },
]